import React from 'react';

import withWindowResize from '../../ui/components/window-resize';
import IntelContainer from '../../main/components/badge-container';

const DLPIntelContainer = ({ type, customBreakpoints }) => (
    ( !type || ( customBreakpoints && customBreakpoints['dlp-v2'] === type ) ) ?
    <div className="intel-banner-container">
        <IntelContainer />
    </div> : null
);

export default withWindowResize(DLPIntelContainer);


